import brandLogo from "../assets/brand-logo.png";

// 黑金徽标：PC 与移动端统一使用同一枚图形
export default function BrandLogo({ size = 36, className = "" }) {
    return (
        <img
            alt="Time Series Model Research 黑金徽标"
            className={className}
            height={size}
            src={brandLogo}
            style={{ width: size, height: size, display: "block" }}
            width={size}
        />
    );
}
